import R from 'ramda'
import { jsonParseWithMangoAtchar } from 'pages/widgets/mapping/common-functions'

const SEND_DM_ACTION_TYPE = 'SEND_DM'
const SEND_DM_DISPLAY_TYPE = 'Send reply'

const isSendDmFormAction = R.both(
  R.propEq('type', SEND_DM_DISPLAY_TYPE),
  R.propEq('action', SEND_DM_ACTION_TYPE)
)

const getActionMedia = R.pipe(R.prop('media'), R.defaultTo([]), R.head)

const validateQuickReply = R.allPass([
  R.prop('quickReply'),
  R.pipe(R.prop('quickReply'), R.isNil, R.complement),
  R.pipe(R.prop('quickReply'), R.isEmpty, R.complement)
])
const getQuickReply = R.cond([
  [
    R.both(R.propEq('action', 'SEND_DM'), validateQuickReply),
    R.applySpec({
      type: R.always('options'),
      options: R.pipe(R.prop('quickReply'), JSON.parse)
    })
  ],
  [R.T, () => undefined]
])

const getCtas = R.pipe(
  R.prop('ctas'),
  R.ifElse(
    R.either(R.isNil, R.isEmpty),
    R.always(undefined),
    jsonParseWithMangoAtchar
  )
)

const convertSendDmFormActionToWidgetAction = R.applySpec({
  type: R.always(SEND_DM_ACTION_TYPE),
  attachmentUrl: R.prop('attachmentUrl'),
  cardUri: R.prop('cardUri'),
  media: getActionMedia,
  message: R.prop('message'),
  quickReply: getQuickReply,
  ctas: getCtas
})

export { isSendDmFormAction, convertSendDmFormActionToWidgetAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/send-dm.js